module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-new"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/shops"
    }
  }, [_vm._v(_vm._s(_vm.$t('Shop List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Shop New')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    on: {
      "click": function($event) {}
    }
  }, [_vm._v(_vm._s(_vm.$t('shop_list.responsible_person')))])])])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Shop New')))]), (_vm.loading) ? _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0)]) : _vm._e(), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("店舗名")]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.shop_name),
      expression: "shop.shop_name"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.shop_name
    },
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": _vm._s(_vm.shop.shop_name)
    },
    on: {
      "keyup": _vm.half,
      "touchend": _vm.half,
      "change": _vm.half,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shop.shop_name = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.shop_name),
      expression: "!validation.shop_name"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])]), _c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("ふりがな")]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.shop_name_furigana),
      expression: "shop.shop_name_furigana"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.shop_name_furigana
    },
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": _vm._s(_vm.shop.shop_name_furigana)
    },
    on: {
      "keyup": _vm.half,
      "touchend": _vm.half,
      "change": _vm.half,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shop.shop_name_furigana = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.shop_name_furigana),
      expression: "!validation.shop_name_furigana"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.invalid_furigana')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("エリア")]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.area),
      expression: "shop.area"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.shop.area)
    },
    on: {
      "keyup": _vm.half,
      "touchend": _vm.half,
      "change": _vm.half,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shop.area = $event.target.value
      }
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaWork),
      expression: "areaWork"
    }],
    staticClass: "area-combo",
    on: {
      "change": [function($event) {
        _vm.areaWork = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.selectedArea]
    }
  }, _vm._l((_vm.areas), function(area) {
    return _c('option', {
      domProps: {
        "value": area.attributes['name']
      }
    }, [_vm._v(_vm._s(area.attributes['name']))])
  }))])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("住所")]), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("〒")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.shop_post_no),
      expression: "shop.shop_post_no"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.shop_post_no || _vm.required.shop_post_no || _vm.required.shop_post_no_format
    },
    attrs: {
      "type": "tel",
      "placeholder": "例)8380141",
      "maxlength": "10"
    },
    domProps: {
      "value": _vm._s(_vm.shop.shop_post_no)
    },
    on: {
      "change": _vm.onChangePostNo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shop.shop_post_no = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.shop_post_no),
      expression: "!validation.shop_post_no"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.not_hyphen')))])]), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.shop_address),
      expression: "shop.shop_address"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.shop_address || _vm.required.shop_address
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.shop.shop_address)
    },
    on: {
      "keyup": _vm.half,
      "touchend": _vm.half,
      "change": _vm.onChangeAddress,
      "blur": _vm.onBlurAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shop.shop_address = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.shop_address),
      expression: "!validation.shop_address"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("電話番号")]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("☎︎")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.shop_tel),
      expression: "shop.shop_tel"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.shop_tel
    },
    attrs: {
      "type": "tel",
      "placeholder": "例)092-123-4567",
      "maxlength": "13"
    },
    domProps: {
      "value": _vm._s(_vm.shop.shop_tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shop.shop_tel = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.shop_tel),
      expression: "!validation.shop_tel"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.fomat_tel')))])]), _c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("FAX番号")]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("📠")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shop.shop_fax),
      expression: "shop.shop_fax"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.shop_fax
    },
    attrs: {
      "type": "tel",
      "placeholder": "例)092-123-4567",
      "maxlength": "13"
    },
    domProps: {
      "value": _vm._s(_vm.shop.shop_fax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shop.shop_fax = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.shop_fax),
      expression: "!validation.shop_fax"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.fomat_fax')))])])]), _vm._m(1), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validation.not_input
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.onClickSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v("保存")])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v("キャンセル")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-157a0538!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/shop-new.pug
// module id = 768
// module chunks = 1